import React from 'react';

const AdditionalNotesSection = ({ isEditing, notes = "", onUpdateNotes }) => {
  const handleNotesChange = (e) => {
    onUpdateNotes(e.target.value);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C] mb-4">ADDITIONAL NOTES (OPTIONAL)</h2>
        <textarea
          value={notes}
          onChange={handleNotesChange}
          placeholder="Mention any key experience or preferences for your next role..."
          disabled={!isEditing}
          className="w-full h-32 px-4 py-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212F] text-[14px] placeholder:text-[#1A212F66] disabled:bg-gray-50 disabled:text-gray-500"
        />
      </div>
    </div>
  );
};

export default AdditionalNotesSection; 